import type { ScalarStatKey } from '../types/buff.types';

export const STAT_LABELS: Partial<Record<ScalarStatKey, string>> = {
  physicalAttack: 'Attaque physique',
  magicAttack: 'Attaque magique',
  physicalDefense: 'Défense physique',
  magicDefense: 'Défense magique',
  moveSpeed: 'Vitesse',
  viewRange: 'Vision',
  pickupReach: 'Portée ramassage',
  critChancePhysical: 'Crit. physique',
  critChanceMagic: 'Crit. magique',
  critMultiplier: 'Mult. critique',
  maxLife: 'Vie max',
  maxShield: 'Bouclier max',
  shieldRegen: 'Régén. bouclier',
  lifeRegenPerSecond: 'Régén. vie',
  spellCastTime: 'Temps de cast',
  inventorySlots: "Emplacements d'inventaire",
  opacity: 'Opacité',
};

// Stats where a lower value is the desirable direction — used to color a
// modifier as a gain (green) when it pushes the stat down (e.g. cast time,
// opacity for stealth).
export const STAT_LOWER_IS_BETTER: ReadonlySet<ScalarStatKey> =
  new Set<ScalarStatKey>(['opacity', 'spellCastTime']);
